/**
 * In-memory queue for analytics emits that fire before an API tenant/client
 * exists (platform chrome `/sign-in` without home jwt).
 *
 * Module-scoped so events survive CustomerSessionProvider remount when jwt
 * appears after login.
 */
import type { CustomerEmitEventInput } from './customerAnalyticsClient.js';

const MAX_PENDING = 32;
const pending: CustomerEmitEventInput[] = [];

export function enqueuePendingCustomerAnalyticsEmit(
  input: CustomerEmitEventInput,
): void {
  if (pending.length >= MAX_PENDING) {
    pending.shift();
  }
  pending.push(input);
}

export function drainPendingCustomerAnalyticsEmits(): CustomerEmitEventInput[] {
  if (pending.length === 0) {
    return [];
  }
  return pending.splice(0, pending.length);
}

/** Test helper — clear the module queue between cases. */
export function clearPendingCustomerAnalyticsEmitsForTests(): void {
  pending.length = 0;
}
